import { Box , AHText } from "arkh";

import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { useWorkspaceTimeZone } from "@/src/OS/WorkspaceTimezone";
import { DateTime } from "luxon";
import { WebDateSelector } from "@/src/components/mobile/WebDateSelector/WebDateSelector";
import { FormattedMessage } from "react-intl";

export function WorkspaceScheduleArchiveDate(props: {
  minDate: DateTime;
  archiveDate: DateTime | null;
  onChangeArchiveDate: (date: DateTime | null) => void;
}) {
  const tz = useWorkspaceTimeZone();
  const intl_tokens = useIntlTokens();
  return (
    <Box style={{ flex: 1 }}>
      <AHText type="subtitle">
        {intl_tokens.ScheduleArchive}
        <AHText color="text-secondary"> ({intl_tokens.Optional})</AHText>
      </AHText>
      <Box spaceVertical="small" style={{ flexDirection: "row", flex: 1 }}>
        <WebDateSelector
          type="datetime"
          timezone={tz}
          placeholder={
            <FormattedMessage
              description="WorkspaceTodoEditMain Date Placeholder"
              defaultMessage="add schedule"
            />
          }
          minDate={props.minDate}
          value={props.archiveDate}
          onChangeValue={(val) => {
            props.onChangeArchiveDate(val);
          }}
        />
      </Box>
    </Box>
  );
}
